module.exports = __webpack_public_path__ + "885323ef.png";